import GeoService from '../services/geo-service';
import { setLoading, setLoaded, setError } from '.';

export const locationRequested = () => ({
  type: 'LOCATION_REQUESTED',
});

export const locationLoaded = (location) => ({
  type: 'LOCATION_LOADED',
  payload: location,
});

export const locationError = (err) => ({
  type: 'LOCATION_ERROR',
  payload: err,
});

export const crdsRequested = () => ({
  type: 'CRDS_REQUESTED',
});

export const crdsLoaded = (crds) => ({
  type: 'CRDS_LOADED',
  payload: crds,
});

export const latLoaded = (crds) => ({
  type: 'LAT_LOADED',
  payload: crds,
});

export const lonLoaded = (crds) => ({
  type: 'LON_LOADED',
  payload: crds,
});

const geoService = new GeoService();

export const getCrds = () => (dispatch) => {
  dispatch(setLoading());
  dispatch(crdsRequested());
  geoService.getLocation()
    .then((data) => {
      const res = data.split(',');
      const crds = {
        lat: res[0],
        lon: res[1],
      };
      dispatch(crdsLoaded(crds));
    })
    .catch((err) => {
      dispatch(setError(err.message));
    });
};

export const getLocation = (crds, lang) => (dispatch) => {
  dispatch(setLoading());
  dispatch(locationRequested());
  geoService.getLocationTitle(crds, lang)
    .then((data) => {
      dispatch(locationLoaded(data));
    })
    .catch((err) => {
      dispatch(setError(err.message));
    });
};

export const setCrdsFromInput = (lang, text) => (dispatch) => {
  dispatch(setLoading());
  geoService.setCrdsFromInput(text, lang)
    .then((data) => {
      dispatch(setLoaded());
      const crds = {
        lat: data.lat,
        lon: data.lng,
      };
      dispatch(crdsLoaded(crds));
    })
    .catch(() => {
      dispatch(setError('Enter a valid city'));
    });
};
